import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { RecoilRoot } from 'recoil';
import RecoilNexus from "recoil-nexus";
import PaymentPlanRequiredModal from "./components/modals/PaymentPlanRequiredModal";
import { ConfigProvider } from 'antd';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { env } from './env';
import { installReadOnlyGuard } from './backend/read-only';
import { RETRIED } from './backend/retry';

installReadOnlyGuard();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30 * 1000,        // Data stays fresh for 30s
      gcTime: 5 * 60 * 1000,       // Cache kept for 5 minutes
      refetchOnWindowFocus: false, // Prevent refetch on tab focus
      // The API client already retried transient read failures; don't stack another round
      retry: (failureCount, error: any) => failureCount < 1 && !error?.[RETRIED],
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <RecoilRoot>
      <RecoilNexus /> {/** Used for getting/setting Recoil state anywhere */}
      <QueryClientProvider client={queryClient}>
        <PaymentPlanRequiredModal />
        <ConfigProvider
          theme={{
            token: {
              colorLink: "#097BB5",
              colorInfo: "#097BB5",
              colorPrimary: "#097BB5"
            },
            components: {
              Collapse: {
                headerBg: "white",
                lineHeight: 1.5,
                borderRadius: 6
              },
              Card: {
                borderRadius: 6
              },
              Table: {
                borderRadius: 6
              }
            },
          }}
        >
          <App />
        </ConfigProvider>
        {env.REACT_APP_ENABLE_TANSTACK === 'true' && <ReactQueryDevtools initialIsOpen={false} />}
      </QueryClientProvider>
    </RecoilRoot>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
